module.exports = __webpack_public_path__ + "static/img/girl-phone.1d0ea08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blast/girl-phone.jpg
// module id = b+Ip
// module chunks = 1